import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6e2cf9c9&lang=less"
script.__scopeId = "data-v-6e2cf9c9"

export default script